import EfImg from '@elem/ui/ef-img';
import { useProductStore } from '../../ProductProvider';
import { PAGE_TYPE } from '../../constants';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function TheComp() {
    const { t } = useLang('theProduct.HighlightsA');
    const { pageType } = useProductStore();
    const BG_MAP: any = {
        [PAGE_TYPE.BASE]: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1726040204858/pc_ksp_02_base.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1726040204858/pc_ksp_02_base.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1726040197249/m_ksp_02_base.jpg',
        },
        [PAGE_TYPE.MOTOR]: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1725594353525/pc_ksp_02.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1725594353525/pc_ksp_02.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1725594663635/m_ksp_02.jpg',
        },
    };
    const bg = BG_MAP[pageType];

    return (
        <div className={styles.itemSelling}>
            <EfImg pc={bg.pc} pad={bg.pad} h5={bg.h5} />
            <div className="item-desc-b">
                <div className="item-line-1">{t('b_ms1')}</div>
                <div className="item-line-2">{t('b_ms2')}</div>
            </div>
        </div>
    );
}
